module.exports = __webpack_public_path__ + "img/close-icon.735bd2b0.svg";